
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class AllergiesSection extends Vue {
  @Prop({ type: String, default: "Allergies" }) readonly title!: string;
}
